var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"kontainer"},[_c('h1',[_vm._v("Bautagebuch")]),_c('p',[_vm._v("Text")]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm"},[_vm._v(" One of three columns ")]),_c('div',{staticClass:"col-sm"},[_vm._v(" One of three columns ")]),_c('div',{staticClass:"col-sm"},[_vm._v(" One of three columns ")])])])])
}]

export { render, staticRenderFns }